// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0px;
  padding: 0px;
  font-family: "Open Sans", sans-serif;
  width: 100%;
  height: 100%;
  /* background-color: #F2F3FC !important; */
}

.bg-theme {
  background: #358696 !important;
  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);
}

/* .headFont{ */
/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */
/* } */
.nav-link {
  font-size: 0.85em !important;
  color: #000 !important;
}

.navbar-nav .nav-link.active,
.navbar-nav .show>.nav-link {
  /* color: var(--bs-navbar-active-color); */
  color: #FFFFFF !important;
  background-color: #83A4CF;
  border-radius: 20px;
  padding: 5px 10px;
  text-align: center;
}

.kratos_nav_icon {
  font-size: 14px;
}

/********* Landing 2 Starts ********/
.dashboard_card {
  font-size: 1.1em;
  color: #000;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
  transition: 0.5s;
  background: #fff;
  border: solid 1px #c3c3c3;
  box-shadow: 1px 1px 25px #33333320;
  padding: 45px 15px 45px 15px;
  margin-top: 20px;
  width: 100%;
}

.dashboard_card img {
  width: 50px;
}

.dashboard_card span {
  display: block;
  padding-top: 15px;
  font-weight: 600;
  line-height: 25px;
}

.dashboard_card:hover {
  box-shadow: 1px 1px 25px #999;
}

/********* Media Queries Starts ********/

@media (min-width: 836px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 991px) {}

@media screen and (max-width: 769px) {}

@media screen and (max-width: 420px) {}


.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 48
}
/* Added code */
.fixed-header .app-main_kratos {
  padding-top: 0px;
  background-color: #F2F3FC !important;
}
.app-theme-white_kratos.app-container {
  background: #F2F3FC !important;
}
.img-fluid_kratos{max-width:100%;overflow-y: hidden;overflow-x: hidden;}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Kratos/LayoutMain_Kratos/Header_Kratos.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,eAAe;AACf,uEAAuE;AACvE,MAAM;AACN;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;EAEE,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wCAAwC;;AAExC;EACE;IACE,iBAAiB;IACjB,2BAA2B;EAC7B;AACF;;AAEA,sCAAsC;;AAEtC,sCAAsC;;AAEtC,sCAAsC;;;AAGtC;EACE;;;;;AAKF;AACA,eAAe;AACf;EACE,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,8BAA8B;AAChC;AACA,kBAAkB,cAAc,CAAC,kBAAkB,CAAC,kBAAkB,CAAC","sourcesContent":["body {\n  margin: 0px;\n  padding: 0px;\n  font-family: \"Open Sans\", sans-serif;\n  width: 100%;\n  height: 100%;\n  /* background-color: #F2F3FC !important; */\n}\n\n.bg-theme {\n  background: #358696 !important;\n  box-shadow: 0px 5px 5px rgb(0 0 0 / 14%);\n}\n\n/* .headFont{ */\n/* font-size: 26px; font-weight: 600; margin-left: 55px; color: #fff; */\n/* } */\n.nav-link {\n  font-size: 0.85em !important;\n  color: #000 !important;\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .show>.nav-link {\n  /* color: var(--bs-navbar-active-color); */\n  color: #FFFFFF !important;\n  background-color: #83A4CF;\n  border-radius: 20px;\n  padding: 5px 10px;\n  text-align: center;\n}\n\n.kratos_nav_icon {\n  font-size: 14px;\n}\n\n/********* Landing 2 Starts ********/\n.dashboard_card {\n  font-size: 1.1em;\n  color: #000;\n  font-weight: 600;\n  text-align: center;\n  cursor: pointer;\n  transition: 0.5s;\n  background: #fff;\n  border: solid 1px #c3c3c3;\n  box-shadow: 1px 1px 25px #33333320;\n  padding: 45px 15px 45px 15px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.dashboard_card img {\n  width: 50px;\n}\n\n.dashboard_card span {\n  display: block;\n  padding-top: 15px;\n  font-weight: 600;\n  line-height: 25px;\n}\n\n.dashboard_card:hover {\n  box-shadow: 1px 1px 25px #999;\n}\n\n/********* Media Queries Starts ********/\n\n@media (min-width: 836px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n}\n\n@media screen and (max-width: 991px) {}\n\n@media screen and (max-width: 769px) {}\n\n@media screen and (max-width: 420px) {}\n\n\n.material-symbols-outlined {\n  font-variation-settings:\n    'FILL' 0,\n    'wght' 400,\n    'GRAD' 0,\n    'opsz' 48\n}\n/* Added code */\n.fixed-header .app-main_kratos {\n  padding-top: 0px;\n  background-color: #F2F3FC !important;\n}\n.app-theme-white_kratos.app-container {\n  background: #F2F3FC !important;\n}\n.img-fluid_kratos{max-width:100%;overflow-y: hidden;overflow-x: hidden;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
